// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/components/layout/protected-route';
import './i18n';
import { PageFallback, WatchlistPage } from './pages/lazy';

/**
 * Attendance watchlist and observations (workforce controls §6): /watchlist — HR with attendance.view, line managers with
 * attendance.view_team (their direct reports; the API scopes every row). A member with neither but linked to an employee record
 * lands on their portal (a notice's link never dead-ends).
 */
export const watchlistRoutes: RouteObject[] = [
  { path: 'watchlist', element: <RequirePermission permissions={['attendance.view', 'attendance.view_team']} any selfServiceTo="/my"><Suspense fallback={<PageFallback />}><WatchlistPage /></Suspense></RequirePermission> },
];
